module.exports = __webpack_public_path__ + "img/Napoli.a85765e4.svg";